import React from 'react';
import { Box, Text } from '@chakra-ui/react';

type ErrorBoundaryProps = {
  children: React.ReactNode;
  label?: string;
};

type ErrorBoundaryState = {
  error: Error | null;
};

/** Logs component stacks in production so React #130 can be mapped to a source file. */
export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state: ErrorBoundaryState = { error: null };

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    const label = this.props.label ?? 'Management Console';
    console.error(`[${label}]`, error);
    if (info.componentStack) {
      console.error(`[${label}] component stack:`, info.componentStack);
    }
  }

  render(): React.ReactNode {
    if (this.state.error) {
      return (
        <Box p={6} color='lighterText'>
          <Text fontWeight='semibold'>Something went wrong loading this page.</Text>
          <Text fontSize='sm' mt={2}>
            Check the browser console for the component stack, then reload.
          </Text>
        </Box>
      );
    }

    return this.props.children;
  }
}
